import queryString from 'query-string';
import axios from 'axios';
import env from 'src/env';

// import Logger from './logger'
import {
  NetworkRequestError,
  RequestError,
  TimeoutRequestError,
  BadRequestError,
  UnauthorizedRequestError,
  NotFoundRequestError,
  ForbiddenRequestError,
  InternalServerRequestError,
} from './errors';

const instance = axios.create({
  baseURL: env.API_SERVER,
});

export default class Request {
  static async send(url, opts = {}) {
    const {
      timeout = 60 * 1000, // 60 second default timeout
      method,
      query,
      data,
      headers = {},
      responseType = 'json',
      withCredentials = true,
      requestInstance = instance,
      transformRequest = [],
      transformResponse = [],
      ...rest
    } = opts;
    const options = {
      responseType,
      timeout,
      ...rest,
      method,
      withCredentials,
      transformRequest: axios.defaults.transformRequest.concat(
        transformRequest,
      ),
      transformResponse: axios.defaults.transformResponse.concat(
        transformResponse,
      ),
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'x-client-id': 'design-pro',
        'x-client-version': process.env.APP_VERSION,
        ...headers,
      },
      data,
    };
    if (
      data &&
      headers['Content-Type'] === 'application/x-www-form-urlencoded'
    ) {
      options.data = queryString.stringify(data);
    }
    let err;
    let result;
    const reqUrl = query ? `${url}?${queryString.stringify(query)}` : url;
    // Logger.info('REQUEST: ', reqUrl, options)
    try {
      result = await requestInstance(reqUrl, options);
      return result;
    } catch (e) {
      if (e.request && e.request.status === 0) {
        err = new NetworkRequestError(e.message);
      } else if (e.code === 'ECONNABORTED') {
        err = new TimeoutRequestError(e.message);
      } else if (e.response && e.response.status >= 400) {
        switch (e.response.status) {
          case 400:
            err = new BadRequestError(e.message);
            break;
          case 401:
            err = new UnauthorizedRequestError(e.message);
            break;
          case 403:
            err = new ForbiddenRequestError(e.message);
            break;
          case 404:
            err = new NotFoundRequestError(e.message);
            break;
          case 500:
            err = new InternalServerRequestError(e.message);
            break;
          default:
            err = new RequestError(e.message);
            break;
        }
      } else {
        err = new RequestError(e.message);
      }
      err.response = e.response;
      err.request = e.request;
    }
    throw err;
  }

  static async get(url, opts = {}) {
    return this.send(url, { ...opts, method: 'get' });
  }

  static async post(url, opts = {}) {
    const options = { ...opts, method: 'post' };
    return this.send(url, options);
  }

  static async put(url, opts = {}) {
    const options = { ...opts, method: 'put' };
    return this.send(url, options);
  }

  static async patch(url, opts = {}) {
    const options = { ...opts, method: 'patch' };
    return this.send(url, options);
  }

  static async delete(url, opts = {}) {
    return this.send(url, { ...opts, method: 'delete' });
  }
}
